import { navigate } from '@reach/router';
import { removeCredentialValue } from 'api/lib/localStorageManagement';
import { useMutation, useQueryClient } from 'react-query';

export function useLogoutMutation() {
  const queryClient = useQueryClient();
  return useMutation(async () => {
    removeCredentialValue('authBearerToken');
    removeCredentialValue('authBearerTokenExpiration');
    removeCredentialValue('authRefreshToken');
    queryClient.removeQueries('/authenticate/token');
    navigate('/');
  });
}
